import { render } from "./gaji-periode-virtual-scroll.vue?vue&type=template&id=3409c219"
import script from "./gaji-periode-virtual-scroll.vue?vue&type=script&lang=js"
export * from "./gaji-periode-virtual-scroll.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__